<template>
  <div class="container d-flex justify-content-center align-items-center" style="min-height: 80vh;">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0">{{ $t('auth.forgot_password') }}</h5>
        </div>
        <div class="card-body">
          <form @submit.prevent="submitEmail">
            <div class="mb-3">
              <label for="email" class="form-label">{{ $t('auth.form.email') }}</label>
              <input
                  type="email"
                  id="email"
                  class="form-control"
                  v-model="email"
                  required
                  :class="{ 'is-invalid': error }"
              />
              <div v-if="error" class="invalid-feedback">
                {{ error }}
              </div>
            </div>

            <div class="text-center">
              <button type="submit" class="btn btn-secondary" :disabled="loading || success">
                <span v-if="!loading">{{ $t('auth.send_reset_link') }}</span>
                <span v-else>
                  <i class="fa fa-spinner fa-spin"></i> {{ $t('auth.sending') }}
                </span>
              </button>
            </div>
          </form>

          <div v-if="success" class="alert alert-success mt-3 text-center">
            {{ $t('auth.email_sent_success') }}
            <div class="small mt-2">
              {{ $t('auth.email_sent_redirect_notice', { seconds: redirectCountdown }) }}
            </div>
          </div>

          <div class="mt-3 text-center">
            <router-link class="text-muted" to="/">{{ $t('auth.back_to_login') }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      loading: false,
      success: false,
      error: null,
      redirectCountdown: 5,
      redirectTimeoutId: null,
      redirectIntervalId: null,
    };
  },
  beforeUnmount() {
    this.clearRedirectTimers();
  },
  methods: {
    async submitEmail() {
      this.loading = true;
      this.success = false;
      this.error = null;
      this.clearRedirectTimers();
      this.redirectCountdown = 5;

      try {
        const response = await this.$axios.post("/forgot-password", {
          email: this.email,
        });

        if (response.status === 200) {
          this.success = true;
          this.email = "";
          this.startRedirectCountdown();
        }
      } catch (err) {
        this.error = err.response?.data?.email || this.$t('auth.error_occurred');
      } finally {
        this.loading = false;
      }
    },
    startRedirectCountdown() {
      this.redirectIntervalId = window.setInterval(() => {
        if (this.redirectCountdown > 1) {
          this.redirectCountdown -= 1;
        }
      }, 1000);

      this.redirectTimeoutId = window.setTimeout(() => {
        this.clearRedirectTimers();
        this.$router.replace('/');
      }, 5000);
    },
    clearRedirectTimers() {
      if (this.redirectIntervalId) {
        window.clearInterval(this.redirectIntervalId);
        this.redirectIntervalId = null;
      }

      if (this.redirectTimeoutId) {
        window.clearTimeout(this.redirectTimeoutId);
        this.redirectTimeoutId = null;
      }
    },
  },
};
</script>

<style scoped>
.card {
  margin-top: 3rem;
}
</style>
